import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

const SWIPER_CONFIGS = {
    recentlyOpened: {
        slidesPerView: 1.5,
        noSwiping: false,
        spaceBetween: 16,
        centeredSlides: false,
        loop: false,
        autoplay: false,
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 24,
                centeredSlides: false,
            },
        },
    },
    detailSlider: {
        slidesPerView: 1.5,
        spaceBetween: 16,
        centeredSlides: false,
        loop: false,
        autoplay: false,
    },
    storeGallery: {
        modules: [Navigation, Pagination, Autoplay],
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: false,
    },
};

const STORE_GALLERY_BULLET_CLASS =
    "swiper-pagination-bullet tw-w-2 tw-h-2 tw-rounded-full tw-bg-white tw-opacity-70 tw-transition-opacity tw-duration-300 tw-cursor-pointer hover:tw-opacity-100";
const STORE_GALLERY_BULLET_ACTIVE_CLASS = "swiper-pagination-bullet-active !tw-opacity-100 !tw-bg-primary";

function destroySwiper(slider) {
    if (slider.swiper) {
        slider.swiper.destroy(true, true);
    }
}

/**
 * @param {string} selector
 */
export function initRecentlyOpenedSwiper(selector = "#recently-opened-stores") {
    /** @type {HTMLElement|null} */
    const slider = document.querySelector(selector);
    if (!slider) return;

    destroySwiper(slider);

    const slideCount = slider.querySelectorAll(".swiper-slide").length;
    if (slideCount === 0) return;

    new Swiper(slider, SWIPER_CONFIGS.recentlyOpened);
}

/**
 * @param {string} selector
 */
export function initDetailSlider(selector = "#locator-details-slider") {
    /** @type {HTMLElement|null} */
    const slider = document.querySelector(selector);
    if (!slider) return;

    destroySwiper(slider);

    const slideCount = slider.querySelectorAll(".swiper-slide").length;
    if (slideCount === 0) return;

    new Swiper(slider, SWIPER_CONFIGS.detailSlider);
}

/**
 * @param {string} selector
 */
export function initStoreItemGalleries(selector = ".store-item-gallery") {
    /** @type {NodeListOf<HTMLElement>} */
    const galleries = document.querySelectorAll(selector);

    galleries.forEach((gallery) => {
        destroySwiper(gallery);

        const slideCount = gallery.querySelectorAll(".swiper-slide").length;
        if (slideCount === 0) return;

        const hasMultipleSlides = slideCount > 1;
        /** @type {HTMLElement|null} */
        const paginationEl = gallery.querySelector(".swiper-pagination");
        /** @type {HTMLElement|null} */
        const nextEl = gallery.querySelector(".swiper-button-next");
        /** @type {HTMLElement|null} */
        const prevEl = gallery.querySelector(".swiper-button-prev");

        if (!hasMultipleSlides) {
            if (paginationEl) paginationEl.style.display = "none";
            if (nextEl) nextEl.style.display = "none";
            if (prevEl) prevEl.style.display = "none";
        }

        new Swiper(gallery, {
            ...SWIPER_CONFIGS.storeGallery,
            loop: hasMultipleSlides,
            pagination: hasMultipleSlides
                ? {
                      el: paginationEl,
                      clickable: true,
                      bulletClass: STORE_GALLERY_BULLET_CLASS,
                      bulletActiveClass: STORE_GALLERY_BULLET_ACTIVE_CLASS,
                  }
                : false,
            navigation: hasMultipleSlides
                ? {
                      nextEl: nextEl,
                      prevEl: prevEl,
                  }
                : false,
        });
    });
}
